import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "invoicing" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "deltas" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderBlock = _resolveComponent("HeaderBlock")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeaderBlock, { class: "header" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t("titles.invoicing")), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.isUserAdmin)
        ? (_openBlock(), _createBlock(_component_Tabs, {
            key: 0,
            color: "primary",
            definitions: [
          {
            title: _ctx.t('labels.openedInvoices'),
            route: { name: 'OpenedInvoices' },
          },
          {
            title: _ctx.t('labels.projectsToInvoice'),
            route: { name: 'ProjectToInvoice' },
          },
          {
            title: _ctx.t('labels.independent'),
            route: { name: 'IndependentInvoices' },
          },
          {
            title: _ctx.t('labels.openedCreditNotes'),
            route: { name: 'OpenedCreditNotes' },
          },
          {
            title: _ctx.t('labels.offerAmountsToValidate'),
            route: { name: 'OfferedAmountsToValidate' },
          },
        ]
          }, null, 8, ["definitions"]))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view)
    ])
  ]))
}